<div class="attachment-pdf-wrapper" *ngIf="attachmentId">

  <div class="modal-header pdf-header">
    <div class="file-name-wrapper" *ngIf="attachment || filename">
      {{filename || attachment.filename}}
    </div>
    
    <div class="download-wrapper" *ngIf="!isChatMessage || isAllowAttachmentSave">
      <button class="btn tn-button-primary" [disabled]="isDisableDownload" (click)="downloadFile()">
        {{'GENERAL.DOWNLOAD' | translate}}
      </button>
    </div>

    <!-- <div class="pdf-page-count" *ngIf="isPDF">
      <div class="input-group">
        <input class="form-control" [(ngModel)]="pageNum" (ngModelChange)="onPageChange($event)">
        <span class="input-group-addon">/ {{ pageCount }}</span>
      </div>
    </div> -->

  </div>
  <!-- <button (click)="getFileUrl()">getFileUrl</button> -->
  <div class="pdf-view-container" *ngIf="isPDF">
    <!-- <div class="pdf-navigation"
      [ngClass]="{'active clickable': pageNum > 1}"
      (click)="prevPage()">
      <i class="fa fa-chevron-left"
        *ngIf="pageNum > 1">
      </i>
    </div> -->
    
    <div class="pdf-container">
      <canvas #imageWatermarkCanvas></canvas>

      <div *ngIf="isPdfLoading" class="pdf-loading-overlay">
        <div class="pdf-loading-spinner"></div>
      </div>

      <!-- render when fileUrl is not undefined -->
      <ngx-extended-pdf-viewer [src]="fileUrl"
        class="full-width"
        [useInlineScripts]="true"
        [height]="'auto'"
        (annotationLayerRendered)="onAnnotationLayerRendered($event)"
        [textLayer]="false"
        [showSidebarButton]="false"
        [showHighlightEditor]="false"
        [showFindButton]="false"
        [showPresentationModeButton]="false"
        [showOpenFileButton]="false"
        [showPrintButton]="false"
        [showDownloadButton]="false"
        [showSecondaryToolbarButton]="false"
        [showRotateButton]="false"
        [showRotateCwButton]="false"
        [showRotateCcwButton]="false"
        [showHandToolButton]="false"
        [handTool]="false"
        [showDrawEditor]="false"
        [showStampEditor]="false"
        [showTextEditor]="false"
        [zoom]="'100%'"
        theme="dark"
        (pdfLoading)="onPdfLoading()"
        (pageRendered)="onPageRendered()"
        (pdfLoadingFailed)="onPdfLoadingFailed()"
        >
      </ngx-extended-pdf-viewer>
      <!-- <div class="pdf-wrapper" [ngStyle]="{
        'height': canvasHeight + 'px', 
        'width': canvasWidth + 'px'
      }"> -->
        <!-- <canvas id="watermark-canvas"></canvas> -->
        <!-- <canvas id="pdf-canvas"></canvas> -->
      <!-- </div> -->
    </div>
<!-- 
    <div class="pdf-navigation"
      [ngClass]="{'active clickable': pageNum < pageCount}"
      (click)="nextPage()">
      <i class="fa fa-chevron-right"
        *ngIf="pageNum < pageCount">
      </i>
    </div> -->

  </div>

</div>
